/**
 * This class represents the attributes of the user
 */

export class User {

    private id: String;
    private email: String;
    private name: String;
    private firstname: String;
    private lastname: String;
    private sex: String;
    private picture: String;
    private settings: Object;
    private role: String;

    /**
     * Constructor of user object
     * @param id ID of user
     * @param name [optional] name of user
     * @param firstname [optional] firstname of user
     * @param lastname [optional] lastname of user
     * @param sex [optional] gender of user
     * @param picture [optional] picture of user
     * @param settings [optional] settings of user
     */

    constructor(id: String, name?: String, firstname?: String, lastname?: String) {
        this.id = id;
        this.name = name;
        this.firstname = firstname;
        this.lastname = lastname;


        if (name) {
            this.setName(name);
        }

        if (firstname) {
            this.setFirstName(firstname);
        }

        if (lastname) {
            this.setLastName(lastname);
        }

    }

    /**
         * This function sets the id
         * @param id id of user
         */
    public setID(id: String): void {
        this.id = id;
    }

    /**
         * This function returns the id
         * @return id id of user
         */
    public getID(): String {
        return this.id;
    }

    /**
         * This function sets the name
         * @param name name of user
         */
    public setName(name: String): void {
        this.name = name;
    }

    /**
         * This function returns the name
         * @return name name of user
         */
    public getName(): String {
        return this.name;
    }

    /**
         * This function sets the firstname
         * @param firstname firstname of user
         */
    public setFirstName(firstname: String): void {
        this.firstname = firstname;
    }

    /**
         * This function returns the firstname
         * @return firstname firstname of user
         */
    public getFirstName(): String {
        if (this.firstname === undefined || this.firstname === '') {
            return '';
        }

        return this.firstname;
    }

    /**
         * This function sets the lastname
         * @param lastname lastname of user
         */
    public setLastName(lastname: String): void {
        this.lastname = lastname;
    }

    /**
         * This function returns the lastname
         * @return lastname lastname of user
         */
    public getLastName(): String {
        if (this.lastname === undefined || this.lastname === null || this.lastname === '') {
            if (this.getFirstName() === '') {
                if (this.getName() !== '' && this.getName() !== null && this.getName() !== undefined) {
                    return this.getName();
                } else {
                    return this.email;
                }
            } else {
                return '';
            }
        }

        return this.lastname;
    }

    /**
         * This function sets the sex
         * @param sex gender of user
         */
    public setSex(sex: String): void {
        this.sex = sex;
    }

    /**
         * This function returns the sex
         * @return sex gender of user
         */
    public getSex(): String {
        return this.sex;
    }

    /**
         * This function sets the picture
         * @param picture picture of user
         */
    public setPicture(picture: String): void {
        this.picture = picture;
    }

    /**
         * This function returns the picture
         * @return picture picture of user
         */
    public getPicture(): String {
        return this.picture;
    }

    /**
         * This function sets the settings
         * @param settings settings of user
         */
    public setSettings(settings: Object): void {
        this.settings = settings;
    }

    /**
         * This function returns the settings
         * @return settings settings of user
         */
    public getSettings(): Object {
        return this.settings;
    }

    /**
     * This function sets the email adress of the user
     * @param email email adress of user
     */
    public setEmail(email: String): void {
        this.email = email;
    }

    public getEmail(): String {
        return this.email;
    }

    /**
     * Setting role of user
     * @param role role
     */
    public setRole(role: String): void {
        this.role = role;
    }

    public getRole(): String {
        return this.role;
    }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/models/user.ts